import React, { useState } from 'react';
import { FormControlLabel } from '@material-ui/core';
import DataProvider from '../../DataProvider.js'
import CustomSwitch from '../CustomSwitch'

export const TabletsSwitch = ({ record, orgProps }) => {
    const dtUID = `${record.id}`
    const orgID = orgProps.record.id

    let orgdata = orgProps.record
    let lists = orgdata.override_dt_notifications
    let checked = true

    for (let tablet of lists) {
        if (`${tablet}` === dtUID) checked = false
    }

    const [switchKey, setSwitchKey] = useState(checked)

    const getOrgData = async () => {
        const data = await DataProvider.getOne('Organizations', { id: orgID })
        return data.data
    }

    return (
        <FormControlLabel
            control={<CustomSwitch checked={switchKey} onChange={async () => {
                setSwitchKey(!switchKey)
                const orgdata = await getOrgData()
                await DataProvider.update('Organizations', { id: orgdata.id, data: { ...orgdata, disable_DTUID: dtUID, override_dt: switchKey }, })
                window.location.reload()
            }} />}
        />)
}

export const ContactListSwitch = ({ record, orgProps }) => {
    const clID = record.id
    const orgID = orgProps.record.id

    let orgdata = orgProps.record
    let lists = orgdata.override_cl_notifications
    let checked = true

    if (lists && lists.includes(clID)) checked = false
    else checked = true

    const [switchKey, setSwitchKey] = useState(checked)

    const getOrgData = async () => {
        const data = await DataProvider.getOne('Organizations', { id: orgID })
        return data.data
    }

    return (
        <FormControlLabel
            control={<CustomSwitch checked={switchKey} onChange={async () => {
                setSwitchKey(!switchKey)
                const orgdata = await getOrgData()
                await DataProvider.update('Organizations', { id: orgdata.id, data: { ...orgdata, disable_CLID: clID, override_cl: switchKey }, })
                window.location.reload()
            }} />}
        />)
}

export const ZoneSwitch = (props) => {
    const [switchKey, setSwitchKey] = useState(true)
    if (!props.zoneprops.override_zone_notifications !== switchKey) setSwitchKey(!props.zoneprops.override_zone_notifications)
    return (
        <FormControlLabel
            control={<CustomSwitch checked={switchKey} onChange={async () => {
                setSwitchKey(!switchKey)
                await DataProvider.update('zones', { id: props.zoneprops.id, data: { ...props.zoneprops, override_zone_notifications: switchKey }, })
                window.location.reload()
            }} />}
        />)
}